import useMasterplanPermissions from '../../../hooks/useMasterplanPermissions';
import { earlyAccessCriticalPath } from '../../../utils/earlyAccessCriticalPath';

/** Column Modules */
import buttonsCol from '../../../components/Schedule/columns/buttonsCol';
import calendarDurationCol from '../../../components/Schedule/columns/calendarDurationCol';
import calendarIdCol from '../../../components/Schedule/columns/calendarIdCol';
import checkedCol from '../../../components/Schedule/columns/checkedCol';
import constraintDateCol from '../../../components/Schedule/columns/constraintDateCol';
import constraintTypeCol from '../../../components/Schedule/columns/constraintTypeCol';
import correlativeIdCol from '../../../components/Schedule/columns/correlativeIdCol';
import costBaseCol from '../../../components/Schedule/columns/costBaseCol';
import costCol from '../../../components/Schedule/columns/costCol';
import { getCriticalPathColumns } from '../../../components/Schedule/columns/criticalPathCols';
import customPredecessorsCol from '../../../components/Schedule/columns/customPredecessorsCol';
import customSucessorsCol from '../../../components/Schedule/columns/customSucessorsCol';
import descriptionCol from '../../../components/Schedule/columns/descriptionCol';
import durationBaseCol from '../../../components/Schedule/columns/durationBaseCol';
import durationCol from '../../../components/Schedule/columns/durationCol';
import endBaseCol from '../../../components/Schedule/columns/endBaseCol';
import endDateCol from '../../../components/Schedule/columns/endDateCol';
import expectedProgressBaseCol from '../../../components/Schedule/columns/expectedProgressBaseCol';
import expectedProgressCol from '../../../components/Schedule/columns/expectedProgressCol';
import freeSlackCol from '../../../components/Schedule/columns/freeSlackCol';
import hhWorkTimeCol from '../../../components/Schedule/columns/hhWorkTimeCol';
import isCriticalCol from '../../../components/Schedule/columns/isCriticalCol';
import ponderatorCol from '../../../components/Schedule/columns/ponderatorCol';
import progressCol from '../../../components/Schedule/columns/progressCol';
import realCostCol from '../../../components/Schedule/columns/realCostCol';
import realWorkCol from '../../../components/Schedule/columns/realWorkCol';
import responsibleCol from '../../../components/Schedule/columns/responsibleCol';
import startBaseCol from '../../../components/Schedule/columns/startBaseCol';
import startDateCol from '../../../components/Schedule/columns/startDateCol';
import statusCol from '../../../components/Schedule/columns/statusCol';
import subcontractIdCol from '../../../components/Schedule/columns/subcontractIdCol';
import tagsCol from '../../../components/Schedule/columns/tagsCol';
import textCol from '../../../components/Schedule/columns/textCol';
import totalSlackCol from '../../../components/Schedule/columns/totalSlackCol';
import uniqueCorrelativeIdCol from '../../../components/Schedule/columns/uniqueCorrelativeIdCol';
import usedCostCol from '../../../components/Schedule/columns/usedCostCol';
import wbsInitialCol from '../../../components/Schedule/columns/wbsInitialCol';
import wbsPreCol from '../../../components/Schedule/columns/wbsPreCol';
import workBaseCol from '../../../components/Schedule/columns/workBaseCol';

/** Permissions */
const userGanttPermissions = useMasterplanPermissions();
const customTypePermissions = ['SA', 'V', 'ACP'];
const fieldNoPermission = customTypePermissions.includes(
  userGanttPermissions.gantt
);
const triggerSetter = fieldNoPermission ? '' : 'click';
const cursorCustomStyle = {
  cursor: fieldNoPermission ? 'not-allowed' : 'pointer'
};

export const ganttColumnsSettingsVersion = 3;

export const table_grid_columns = (gantt, t, permissionGantt = '') => {
  let columns = [
    wbsPreCol(gantt, t),
    wbsInitialCol(gantt, t),
    checkedCol(gantt, t),
    correlativeIdCol(gantt, t),
    textCol(gantt, t),
    buttonsCol(gantt, t, permissionGantt),
    uniqueCorrelativeIdCol(gantt, t),
    statusCol(gantt, t),
    startDateCol(gantt, t),
    durationCol(gantt, t),
    endDateCol(gantt, t),
    progressCol(gantt, t),
    expectedProgressCol(gantt, t),
    freeSlackCol(gantt, t),
    totalSlackCol(gantt, t),
    customPredecessorsCol(gantt, t),
    customSucessorsCol(gantt, t),
    constraintTypeCol(
      gantt,
      t,
      fieldNoPermission,
      triggerSetter,
      cursorCustomStyle
    ),
    calendarIdCol(gantt, t),
    constraintDateCol(gantt),
    realWorkCol(gantt, t),
    hhWorkTimeCol(gantt, t),
    costCol(gantt, t),
    usedCostCol(gantt, t),
    realCostCol(gantt, t),
    ponderatorCol(gantt, t),
    isCriticalCol(gantt, t),
    startBaseCol(gantt, t),
    endBaseCol(gantt, t),
    expectedProgressBaseCol(gantt, t),
    workBaseCol(gantt, t),
    costBaseCol(gantt, t),
    durationBaseCol(gantt, t),
    responsibleCol(
      gantt,
      t,
      fieldNoPermission,
      triggerSetter,
      cursorCustomStyle
    ),
    subcontractIdCol(
      gantt,
      t,
      fieldNoPermission,
      triggerSetter,
      cursorCustomStyle
    ),
    tagsCol(gantt, t, fieldNoPermission, triggerSetter, cursorCustomStyle),
    descriptionCol(gantt, t),
    calendarDurationCol(gantt, t)
  ];

  if (earlyAccessCriticalPath()) {
    columns.push(...getCriticalPathColumns(gantt));
  }
  return columns;
};
